'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); // 'Use Smartphone'


require('./signature-modal.scss');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = require('react-intl');

var _drawTab = require('./draw-tab');

var _drawTab2 = _interopRequireDefault(_drawTab);

var _savedTab = require('./saved-tab');

var _savedTab2 = _interopRequireDefault(_savedTab);

var _errorTab = require('./error-tab');

var _errorTab2 = _interopRequireDefault(_errorTab);

var _emailTab = require('./email-tab');

var _emailTab2 = _interopRequireDefault(_emailTab);

var _typeInTab = require('./type-in-tab');

var _typeInTab2 = _interopRequireDefault(_typeInTab);

var _uploadTab = require('./upload-tab');

var _uploadTab2 = _interopRequireDefault(_uploadTab);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _loader = require('signer/components/common/loader');

var _loader2 = _interopRequireDefault(_loader);

var _errors = require('signer/api/errors');

var _errors2 = _interopRequireDefault(_errors);

var _setInterval = require('common/utils/set-interval');

var _setInterval2 = _interopRequireDefault(_setInterval);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _makeComponentIntl = require('common/utils/make-component-intl');

var _makeComponentIntl2 = _interopRequireDefault(_makeComponentIntl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx('span', {
    className: 'm-sign-modal--menu--item--icon'
});

var _ref2 = _jsx(_loader2['default'], {
    className: 'm-sign-modal--loader--image whitelabel-dot-loader'
});

var SignatureModal = _react2['default'].createClass({
    displayName: 'SignatureModal',


    propTypes: {
        'app': _react2['default'].PropTypes.object.isRequired, // Application
        'type': _react2['default'].PropTypes.string, // Signature or initials (see SignatureModal.TYPE_*)
        'isMobile': _react2['default'].PropTypes.bool, // Whether it should have mobile behavior
        'initialTab': _react2['default'].PropTypes.string, // The tab shown at first (see SignatureModal.TAB_*)
        'settings': _react2['default'].PropTypes.object, // Define which tabs should be shown { tabId => true/false }
        'onBeforeInsert': _react2['default'].PropTypes.func, // Called before the signature is inserted
        'onComplete': _react2['default'].PropTypes.func.isRequired, // Called when the user has selected a signature for action: function(signature, insertEverywhere)
        'onClose': _react2['default'].PropTypes.func, // Called when the signature modal is closed by the user
        'onSelectTab': _react2['default'].PropTypes.func, // Called when the user selects a tab
        'locales': _react2['default'].PropTypes.array.isRequired, // Selected locale (list of one)
        'messages': _react2['default'].PropTypes.object, // Internationalized text
        'canInsertEverywhere': _react2['default'].PropTypes.bool, // Whether to show the option to insert everywhere
        'emailGuid': _react2['default'].PropTypes.string, // Email guid for signature upload,
        'emailUploadAddress': _react2['default'].PropTypes.string, // Email address to send signatures to
        'buttonText': _react2['default'].PropTypes.string // Text to be displayed on the CTA (only when canInsertEverywhere=false)
    },

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'type': _constants2['default'].TYPE_SIGNATURE,
            'isMobile': true,
            'initialTab': _constants2['default'].TAB_SAVED,
            'messages': require('./translations/en-US.json'),
            'settings': {},
            'canInsertEverywhere': true,
            'onBeforeInsert': function onBeforeInsert() {}
        };
    },

    getInitialState: function getInitialState() {
        return Object.assign({
            'selectedSignatureId': null,
            'deviceOrientation': this.detectDeviceOrientation(),
            'displayOrientation': this.props.isMobile ? _constants2['default'].ORIENTATION_PORTRAIT : _constants2['default'].ORIENTATION_LANDSCAPE,
            'isSignature': this.props.type === _constants2['default'].TYPE_SIGNATURE,
            'isInitials': this.props.type === _constants2['default'].TYPE_INITIALS,
            'screenSize': this.detectScreenSize(),
            'isCreatingSignature': false,
            'error': {}
        }, this.getStates());
    },

    componentDidMount: function componentDidMount() {
        var _this = this;

        if (this.state.isLoading) {
            // Load the user signatures (will only fetch them if not already cached)
            this.props.app.user.getSignatures(this.props.type).load().then(function () {
                _this.setState(_this.getStates());
            });
        }

        if (this.props.isMobile) {
            var adjTimer;

            var adjustOrientationAndSize = function adjustOrientationAndSize() {

                if (!_this.isMounted()) return clearInterval(adjTimer);

                var orientation = _this.detectDeviceOrientation();
                var screenSize = _this.detectScreenSize();

                if (orientation !== _this.state.deviceOrientation || screenSize !== _this.state.screenSize) {
                    console.log('New orientation: ' + orientation + ', screen size: ' + screenSize);
                }

                _this.adjustDimensions();

                _this.setState({
                    'deviceOrientation': orientation,
                    'screenSize': screenSize
                });
            };

            // Orientation and size detection
            // adjust size on a timer. Do NOT use listeners! This fixes strange iOS bugs (CC)
            adjTimer = (0, _setInterval2['default'])(adjustOrientationAndSize, 250);
            adjustOrientationAndSize();
        }
    },

    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
        this.setState(this.getStates(newProps));
    },

    //  ----  HELPERS  ------------------------------------

    getStates: function getStates(newProps) {
        var props = newProps || this.props;
        var user = props.app.user;
        var signatures = user.getSignatures(props.type);
        var isLoading = !signatures.data || signatures.loading === true;
        return {
            'isLoading': isLoading,
            'selectedTab': isLoading ? null : this.getInitialTab(props, signatures),
            'savedSignatures': isLoading ? null : signatures
        };
    },

    detectDeviceOrientation: function detectDeviceOrientation() {
        if (this.props.isMobile && window.screen) {
            if (window.orientation !== void 0 && Math.abs(window.orientation) === 90 || window.screen && window.screen.width > window.screen.height) {
                // NOTE: Only used for in-browser mobile simulators because they don't emulate orientation changes correctly
                return _constants2['default'].ORIENTATION_LANDSCAPE;
            } else {
                return _constants2['default'].ORIENTATION_PORTRAIT;
            }
        } else {
            return _constants2['default'].ORIENTATION_LANDSCAPE;
        }
    },

    detectScreenSize: function detectScreenSize() {
        if (window.screen) {
            var w = window.screen.width;
            if (w <= 690) {
                return _constants2['default'].SCREEN_SMALL;
            } else if (w > 690 && w <= 900) {
                return _constants2['default'].SCREEN_MEDIUM;
            }
        }
        return _constants2['default'].SCREEN_LARGE;
    },

    isRotated: function isRotated() {
        // NOTE: Disabled for now
        // var isSmallScreen = (this.state.screenSize === CONSTANTS.SCREEN_SMALL);
        // return (isSmallScreen && this.state.deviceOrientation != this.state.displayOrientation);
        return false;
    },

    adjustDimensions: function adjustDimensions() {
        if (window.screen && this.props.isMobile && this.state.screenSize === _constants2['default'].SCREEN_SMALL) {

            // NOTE: The height is must be at least 270px to prevent the action bar from running into the menu.
            // Also, in such case, the keyboard is most likely up, so the user can dismiss it to see the rest of the modal.

            var root = $(_reactDom2['default'].findDOMNode(this));
            var h = Math.max(270, window.innerHeight);
            var w = window.innerWidth;
            var offset = (h - w) / 2;

            if (this.isRotated()) {
                root.css({
                    'width': h + 'px',
                    'height': w + 'px',
                    'top': offset + 'px',
                    'left': -1 * offset + 'px'
                });
            } else {
                root.css({
                    'width': w + 'px',
                    'height': h + 'px',
                    'top': 0,
                    'left': 0
                });
            }
        }
    },

    shouldShowTab: function shouldShowTab(tabId) {
        // Block Upload and Smartphone (email) on mobile
        if (this.props.isMobile && (tabId === _constants2['default'].TAB_UPLOAD || tabId === _constants2['default'].TAB_EMAIL)) {
            return false;
        }

        // Never show error tab in menu
        if (tabId === _constants2['default'].TAB_ERROR) return false;

        // Show if true or not specified
        return this.state.selectedTab === tabId || this.props.settings[tabId] !== false;
    },

    getInitialTab: function getInitialTab(props, signatures) {

        var tabId = props.initialTab;
        var hasVisibleTab = false;
        var i;

        for (i in _constants2['default'].TABS) {
            if (props.settings[_constants2['default'].TABS[i]] !== false) {
                hasVisibleTab = true;
                break;
            }
        }

        if (!hasVisibleTab) {
            // No visible tab due to restrictions from settings
            tabId = _constants2['default'].TAB_DRAW;
        } else if (tabId === _constants2['default'].TAB_SAVED && signatures.length === 0) {
            // Default to the next visible tab if there aren't any saved signatures
            for (i in _constants2['default'].TABS) {
                if (_constants2['default'].TABS[i] !== _constants2['default'].TAB_SAVED && props.settings[_constants2['default'].TABS[i]] !== false) {
                    tabId = _constants2['default'].TABS[i];
                    break;
                }
            }
        } else if (props.settings[tabId] === false) {
            // Select the first visible tab if the specified can't be displayed
            for (i in _constants2['default'].TABS) {
                if (_constants2['default'].TABS[i] !== tabId && props.settings[_constants2['default'].TABS[i]] !== false) {
                    tabId = _constants2['default'].TABS[i];
                    break;
                }
            }
        }

        return tabId;
    },

    //  ----  BEHAVIOR  -----------------------------------

    selectTab: function selectTab(tabId) {
        console.log('Selecting signature modal tab "' + tabId + '"');
        this.setState({
            'selectedTab': tabId
        });
    },

    close: function close() {
        console.log('Closing signature modal');
        if (this.props.onClose) {
            this.props.onClose();
        }
    },

    insert: function insert(signature, insertEverywhere, creationStarted) {
        if (creationStarted === true) {
            this.setState({
                'isCreatingSignature': true
            });
        } else {
            console.log('Inserting signature ' + signature.guid + (insertEverywhere ? ' everywhere' : ''));
            this.setState({
                'isCreatingSignature': false
            });
            this.props.onComplete(signature, insertEverywhere, true);
        }
    },

    handleError: function handleError(error) {

        this.setState({
            'isCreatingSignature': false,
            'error': error
        });

        if (error.code === _errors2['default'].NETWORK || error.code === _errors2['default'].CREDENTIALS) {
            // No need to trigger error reporting in this case since a special error screen
            // will be shown instead.
            return;
        }

        // Right now, tabbed error handling is only turned on for Desktop clients
        if (!this.props.app.isMobile) {
            this.selectTab(_constants2['default'].TAB_ERROR);
        } else {
            console.error('Signature Modal Error: ' + (error ? error.message : ''));
        }
    },

    errorOnContinue: function errorOnContinue() {
        this.selectTab(_constants2['default'].TAB_SAVED);
    },

    //  ----  RENDERING  ----------------------------------

    renderMenu: function renderMenu() {

        var menuItems = [];
        var classes;

        for (var k in _constants2['default'].TABS) {

            var tabId = _constants2['default'].TABS[k];
            if (!this.shouldShowTab(tabId)) {
                continue;
            }

            classes = {
                'm-sign-modal--menu--item': true,
                'is-compact': this.props.isMobile,
                'is-selected': this.state.selectedTab === tabId,
                'whitelabel-signature-modal-tab': true
            };

            classes[tabId] = true;

            menuItems.push(_jsx('div', {
                className: (0, _classnames2['default'])(classes),
                onClick: this.selectTab.bind(null, tabId)
            }, 'sign-modal-menuitem-' + tabId, _ref, _jsx('span', {
                className: 'm-sign-modal--menu--item--label'
            }, void 0, _jsx(_reactIntl.FormattedMessage, {
                id: 'signModal.menu.labelText',
                values: { tabId: tabId + (tabId == _constants2['default'].TAB_SAVED ? this.props.type : '') }
            }))));
        }

        return _jsx('div', {
            className: 'm-sign-modal--menu'
        }, void 0, menuItems);
    },

    renderTabs: function renderTabs() {
        var _this2 = this;

        var tabs = _constants2['default'].TABS.filter(function (id) {
            return _this2.state.selectedTab === id;
        }).map(function (id) {
            return _this2.renderTab(id);
        });
        return _jsx('div', {
            className: 'm-sign-modal--tabs'
        }, void 0, tabs);
    },

    renderTab: function renderTab(tabId) {

        var tab;
        var key = 'tab-' + tabId;
        var isSelected = this.state.selectedTab === tabId;
        var commonProps = {
            'app': this.props.app,
            'type': this.props.type,
            'onBeforeInsert': this.props.onBeforeInsert,
            'onInsert': this.insert,
            'onClose': this.close,
            'onError': this.handleError,
            'isSelected': isSelected,
            'locales': this.props.locales,
            'messages': this.props.messages,
            'deviceOrientation': this.state.deviceOrientation,
            'screenSize': this.state.screenSize,
            'isMobile': this.props.isMobile,
            'canInsertEverywhere': this.props.canInsertEverywhere,
            'emailGuid': this.props.emailGuid,
            'emailUploadAddress': this.props.emailUploadAddress,
            'buttonText': this.props.buttonText,
            'intl': this.props.intl
        };

        switch (tabId) {

            case _constants2['default'].TAB_SAVED:
                tab = _react2['default'].createElement(_savedTab2['default'], _extends({
                    key: key,
                    savedSignatures: this.state.savedSignatures
                }, commonProps));
                break;

            case _constants2['default'].TAB_DRAW:
                tab = _react2['default'].createElement(_drawTab2['default'], _extends({
                    key: key,
                    displayOrientation: this.state.displayOrientation
                }, commonProps));
                break;

            case _constants2['default'].TAB_TYPE:
                tab = _react2['default'].createElement(_typeInTab2['default'], _extends({
                    key: key
                }, commonProps));
                break;

            case _constants2['default'].TAB_UPLOAD:
                tab = _react2['default'].createElement(_uploadTab2['default'], _extends({
                    key: key
                }, commonProps));
                break;

            case _constants2['default'].TAB_EMAIL:
                tab = _react2['default'].createElement(_emailTab2['default'], _extends({
                    key: key
                }, commonProps));
                break;

            case _constants2['default'].TAB_ERROR:
                tab = _react2['default'].createElement(_errorTab2['default'], _extends({
                    key: key
                }, commonProps, {
                    error: this.state.error,
                    onContinue: this.errorOnContinue }));
                break;

            default:
                throw new Error('Invalid tab id: ' + tabId);

        }

        return tab;
    },

    render: function render() {
        var isRotated = this.isRotated();
        var classes = {
            'm-sign-modal': true,
            'is-mobile': this.props.isMobile,
            'is-desktop': !this.props.isMobile,
            'is-rotated': isRotated,
            'is-not-rotated': !isRotated,
            'can-insert-everywhere': this.props.canInsertEverywhere
        };
        classes['screen-' + this.state.screenSize] = true;
        classes['orientation-' + this.state.deviceOrientation] = true;

        var isLoading = this.state.isLoading || this.state.isCreatingSignature;
        var loaderText = this.state.isCreatingSignature ? _jsx(_reactIntl.FormattedMessage, {
            id: 'signModal.loader.text',
            values: { type: this.props.type }
        }) : null;
        var loader = _jsx('div', {
            className: 'm-sign-modal--loader'
        }, void 0, _ref2, _jsx('span', {
            className: 'm-sign-modal--loader--text'
        }, void 0, loaderText));

        var closeBox = _jsx('div', {
            className: 'm-sign-modal--close-box',
            onClick: this.close
        }, void 0, _jsx('img', {
            src: require('./x@2x.png')
        }));

        // Render the signature modal
        return _jsx('div', {
            className: (0, _classnames2['default'])(classes)
        }, void 0, isLoading ? loader : null, isLoading ? null : this.renderMenu(), isLoading || this.props.isMobile ? null : closeBox, isLoading ? null : this.renderTabs());
    }
});

module.exports = (0, _makeComponentIntl2['default'])(SignatureModal);


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/signature-modal.jsx
 ** module id = 668
 ** module chunks = 0
 **/